import { validateExcludeRegex } from 'hb-react/shared/utils/validators/excludeRegex';
import { validateMaxEmailsInline } from 'hb-react/shared/utils/validators/maxEmailsInline';
import { validateMaxLength } from 'hb-react/shared/utils/validators/maxLength';
import { validateMinLength } from 'hb-react/shared/utils/validators/minLength';
import { validateRegex } from 'hb-react/shared/utils/validators/regex';
import { validateRequired } from 'hb-react/shared/utils/validators/required';
import {
  validateUrlFormat,
  validateUrlAndMailToFormat,
  validateUrlFormatWithProtocol,
} from 'hb-react/shared/utils/validators/urlFormat';
import { validateEmailsInline } from 'hb-react/shared/utils/validators/validEmailsInline';

interface ValidateTextProps {
  errorMessage?: string;
  excludeRegex?: RegExp;
  maxEmailsInline?: number;
  maxLength?: number;
  minLength?: number;
  regex?: RegExp;
  required?: boolean;
  urlAndMailToFormat?: boolean;
  urlFormat?: boolean;
  urlFormatWithProtocol?: boolean;
  validEmailsInline?: boolean;
  value?: string;
}

export const validateText = ({
  errorMessage,
  excludeRegex,
  maxEmailsInline,
  maxLength,
  minLength,
  regex,
  required,
  urlAndMailToFormat,
  urlFormat,
  urlFormatWithProtocol,
  validEmailsInline,
  value,
}: ValidateTextProps) => {
  const validations: {
    condition?: boolean;
    func: (value?: string, ...args: any[]) => boolean | string | undefined;
    args: any[];
  }[] = [
    { condition: required, func: validateRequired, args: [] },
    {
      condition: !!minLength,
      func: validateMinLength,
      args: [minLength],
    },
    {
      condition: !!maxLength,
      func: validateMaxLength,
      args: [maxLength],
    },
    { condition: urlFormat, func: validateUrlFormat, args: [] },
    {
      condition: urlFormatWithProtocol,
      func: validateUrlFormatWithProtocol,
      args: [],
    },
    {
      condition: urlAndMailToFormat,
      func: validateUrlAndMailToFormat,
      args: [],
    },
    {
      condition: !!regex,
      func: validateRegex,
      args: [regex, errorMessage],
    },
    { condition: validEmailsInline, func: validateEmailsInline, args: [] },
    {
      condition: !!maxEmailsInline,
      func: validateMaxEmailsInline,
      args: [maxEmailsInline],
    },
    {
      condition: !!excludeRegex,
      func: validateExcludeRegex,
      args: [excludeRegex, errorMessage],
    },
  ];

  const failedValidation = validations.find((validation) => {
    if (validation.condition) {
      return validation.func(value, ...validation.args);
    }

    return false;
  });

  const error = failedValidation?.func(value, ...failedValidation.args);

  return error;
};
